import React from 'react'

const MobileFeatureCard = ({ icon: Icon, title, color }) => (
    <div className="text-center p-4 bg-white rounded-xl shadow-sm">
        <Icon className={`h-8 w-8 ${color} mx-auto mb-2`} />
        <p className="text-xs text-gray-600">{title}</p>
    </div>
)

export default MobileFeatureCard